exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".terms .terms_page{padding:0 10px}.terms .terms_page .terms_title{margin-top:80px;margin-bottom:15px;text-align:left;font-size:46px}.terms .terms_page .terms_content{font-size:16px}.terms .terms_page .terms_content,.terms .terms_page .terms_main{text-align:left;margin-bottom:15px}.terms .terms_page .terms_main h1{font-size:22px;font-weight:400;color:#0084ff;margin-bottom:10px}.terms .terms_page .terms_main p{font-size:16px;margin-bottom:25px}@media only screen and (max-width:414px){.terms .terms_page .terms_title{font-size:32px}.terms .terms_page .terms_main h1{font-size:18px}.terms .terms_page .terms_main p{font-size:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19e39e40","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Common/termsOfService.vue
// module id = 347
// module chunks = 0